/* eslint-disable jsx-a11y/label-has-for */
import React, { useCallback, useEffect, useState } from "react";
import { Button, FormCustomControl, Modal } from "react-blueprint-library";
import { Dropdown, DropdownButton } from "react-bootstrap";
import InputMask from "react-input-mask";
import { STATES } from "../../../constants/States";
import LostDataModal from "../../SharedComponents/LostDataModal";
import Moment from "moment";
import { COUNTRIES } from "../../../constants/countries";
import { clickFunc, isValidDate } from "../../../common/Functions";

const InstitutionModal = ({
  showAddInstitutionModal,
  closeAddInstitutionModal,
  DEGREES,
  onKeyDown,
  handleToggle,
  addData,
  editInstitutionDetails,
  updateInstituteData,
  isReviewEditInstitution,
  setIsReviewEditInstitution,
  setEditInstitutionDetails,
}) => {
  const [formHasError, setFormHasError] = useState(false);
  const [formHasChanged, setFormHasChanged] = useState(false);
  const [institutionName, setInstitutionName] = useState("");
  const [cntrlWithFocus, setCntrlWithFocus] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [showState, setShowState] = useState(false);
  const [country, setCountry] = useState("");
  const [isDegreeReceive, setIsDegreeReceive] = useState("");
  const [currentInstitutionCheck, setCurrentInstitutionCheck] = useState(false);
  const [majorIn, setMajorIn] = useState("");
  const [enableDegreeOption, setEnableDegreeOption] = useState(false);
  const [degree, setDegree] = useState();
  const [isAddButtonDisable, setIsAddButtonDisable] = useState(true);
  const [showLostDataModal, setShowLostDataModal] = useState(false);

  let hasError = false;

  const handleChange = (event) => {
    if (event.target.id === "country_id_modal") {
      if (event.target.value === "US") {
        setShowState(true);
      } else {
        setShowState(false);
        setState("");
        let obj_error = document.getElementById("state_modal_id_error");
        obj_error.style.display = "none";
        let ctrlToValidate = document.getElementById("state_id_modal_opt");
        ctrlToValidate.removeAttribute("style");
      }
      setCountry(event.target.value);
    }

    if (event.target.id === "state_id_modal_opt") {
      setState(event.target.value);
    }
    if (event.target.id === "city_modal") {
      setCity(event.target.value);
    }
    if (event.target.id === "major_in") {
      setMajorIn(event.target.value);
    }
    if (event.target.id === "institution_name_modal") {
      setInstitutionName(event.target.value);
    }
    if (event.target.id === "isCurrentInstitution") {
      setCurrentInstitutionCheck(!currentInstitutionCheck);
    }
    if (event.target.id === "degree_name") {
      setDegree(event.target.innerText);
    }
    if (event.target.id === "recievedDegreeYes") {
      setIsDegreeReceive("Yes");
      setEnableDegreeOption(true);
    }
    if (event.target.id === "recievedDegreeNo") {
      setIsDegreeReceive("No");
      setEnableDegreeOption(false);
    }
    if (event.target.id === "start_date_modal") {
      const cleanValue = event.target.value.replace(/_/g, "");
      setStartDate(cleanValue);
    }
    if (event.target.id === "end_date_modal") {
      const cleanValue = event.target.value.replace(/_/g, "");
      setEndDate(cleanValue);
    }
    setFormHasChanged(true);
  };

  const onBlur = async (event) => {
    let obj_error;

    if (
      cntrlWithFocus.includes("option") &&
      cntrlWithFocus !== event.target.id
    ) {
    } else {
      if (event.target.id.includes("degree_name")) {
        obj_error = document.getElementById("degree_modal_name_error");

        if (event.target.innerText.trim(" ").length === 0) {
          event.target.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          if (event.target.className !== "dropdown-item") {
            event.target.removeAttribute("style");
          } else {
            let educationCtrl = document.getElementById(event.target.id);
            educationCtrl.style.border = "1.5px solid #6b748e";
          }
        }
      }
      if (
        event.target.id.includes("degree_option") &&
        cntrlWithFocus !== "degree_option"
      ) {
        obj_error = document.getElementById("degree_modal_name_error");
        let ctrlToValidate = document.getElementById("degree_name");
        if (degree.length === 0) {
          ctrlToValidate.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          if (ctrlToValidate.className !== "dropdown-item") {
            ctrlToValidate.removeAttribute("style");
          } else {
            let genderCtrl2 = document.getElementById("degree_name");
            genderCtrl2.style.border = "1.5px solid #6b748e";
          }
        }
      }
      if (event.target.id.includes("institution_name_modal")) {
        obj_error = document.getElementById("institution_modal_name_error");
        if (
          event.target.value.trim(" ").length < 3 ||
          institutionName.length < 3
        ) {
          event.target.style.color = "#e21224";
          event.target.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          event.target.style.color = "#6b748e";
          obj_error.style.display = "none";
          event.target.removeAttribute("style");
        }
      }
      if (event.target.id.includes("major_in")) {
        obj_error = document.getElementById("major_modal_in_error");
        if (event.target.value.trim(" ").length < 3 || majorIn.length < 3) {
          event.target.style.border = "1.5px solid #e21224";
          event.target.style.color = "#e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          event.target.removeAttribute("style");
        }
      }
      if (event.target.id.includes("city_modal")) {
        obj_error = document.getElementById("city_modal_error");
        if (event.target.value.trim(" ").length < 2 || city.length < 2) {
          event.target.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          event.target.style.color = "#e21224";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          event.target.removeAttribute("style");
          event.target.style.color = "#555";
        }
      }
      if (event.target.id.includes("state_id") && showState === true) {
        obj_error = document.getElementById("state_modal_id_error");
        let obj_err = document.getElementById("state_id_modal_opt");

        if (event.target.innerText.trim("").length === 0) {
          obj_err.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          if (event.target.className !== "dropdown-item") {
            obj_err.removeAttribute("style");
          } else {
            let educationCtrl = document.getElementById(event.target.id);
            educationCtrl.style.border = "1.5px solid #6b748e";
          }
        }
      }
      if (
        showState === true &&
        event.target.id.includes("state_option") &&
        cntrlWithFocus !== "state_option"
      ) {
        obj_error = document.getElementById("state_modal_id_error");
        let ctrlToValidate = document.getElementById("state_id_modal_opt");
        if (state.length === 0) {
          ctrlToValidate.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          if (ctrlToValidate.className !== "dropdown-item") {
            ctrlToValidate.removeAttribute("style");
          } else {
            let genderCtrl2 = document.getElementById("state_id_modal_opt");
            genderCtrl2.style.border = "1.5px solid #6b748e";
          }
        }
      }
      if (event.target.id.includes("country_id_modal")) {
        obj_error = document.getElementById("country_modal_id_error");

        if (event.target.innerText.trim(" ").length === 0) {
          event.target.style.border = "1.5px solid #e21224";
          obj_error.style.display = "block";
          hasError = true;
        } else {
          obj_error.style.display = "none";
          if (event.target.className !== "dropdown-item") {
            event.target.removeAttribute("style");
          } else {
            let educationCtrl = document.getElementById(event.target.id);
            educationCtrl.style.border = "1.5px solid #6b748e";
          }
        }
      }
      if (event.target.id.includes("_date")) {
        let date = new Moment();
        let start_date_modal =
          startDate === "" ? "" : new Moment(startDate, "MM/YYYY");
        let end_date_modal =
          endDate === "" ? "" : new Moment(endDate, "MM/YYYY");

        if (event.target.id === "start_date_modal") {
          var error;
          error = document.getElementById("start_date_error_modal");
          let currDate3 = Moment();
          let dateParts3 = event.target.value.split("/");
          let month3 = dateParts3[0];
          let year3 = dateParts3[1];
          let dateCalc3 = Moment(year3 + "-" + month3);
          let yearDiff3 = currDate3.diff(dateCalc3, "year");

          if (
            event.target.value.includes("_") ||
            event.target.value === "" ||
            !isValidDate(event.target.value) ||
            event.target.value.includes("0000")
          ) {
            event.target.style.border = "1.5px solid #e21224";
            error.style.display = "block";
            error.innerText = "Please enter a Start Date";
            event.target.style.color = "#e21224";
            hasError = true;
            hasError = true;
          } else if (dateCalc3 > currDate3 || start_date_modal.isAfter(date)) {
            event.target.style.border = "1.5px solid #e21224";
            error.innerText = "Start Date cannot be a future date";
            error.style.display = "block";
            event.target.style.color = "#e21224";
            hasError = true;
          } else if (yearDiff3 >= 80) {
            event.target.style.border = "1.5px solid #e21224";
            error.innerText = "Start Date cannot be more than 80 years ago";
            error.style.display = "block";
            event.target.style.color = "#e21224";
            hasError = true;
          } else if (
            end_date_modal !== "" &&
            start_date_modal.isAfter(end_date_modal)
          ) {
            error.innerText = "Start Date cannot be after End Date";
            event.target.style.border = "1.5px solid #e21224";
            error.style.display = "block";
            event.target.style.color = "#e21224";
            hasError = true;
          } else {
            error.style.display = "none";
            event.target.removeAttribute("style");
            event.target.style.color = "#555";
            let end_date_error = document.getElementById(
              "end_date_error_modal"
            );
            if (end_date_error.style.display === "block") {
              // run onblur for start_date_modal
              let end_date_error = new Event("blur");
              Object.defineProperty(end_date_error, "target", {
                writable: false,
                value: document.getElementById("end_date_modal"),
              });

              onBlur(end_date_error);
            }
          }
        }
        if (event.target.id === "end_date_modal") {
          var obj_error2;
          let dateParts3 = event.target.value.split("/");
          let month3 = dateParts3[0];
          let year3 = dateParts3[1];
          let dateCalc3 = Moment(year3 + "-" + month3);
          let pls3yrs = Moment().add(3, "years").subtract(1, "months");
          obj_error2 = document.getElementById("end_date_error_modal");
          let currDate3 = Moment();
          let yearDiff3 = currDate3.diff(dateCalc3, "year");
          if (
            event.target.value.includes("_") ||
            event.target.value === "" ||
            !isValidDate(event.target.value) ||
            event.target.value.includes("0000")
          ) {
            event.target.style.border = "1.5px solid #e21224";
            obj_error2.style.display = "block";
            obj_error2.innerText = "Please enter an End Date";
            event.target.style.color = "#e21224";
            hasError = true;
          } else if (yearDiff3 >= 80) {
            event.target.style.border = "1.5px solid #e21224";
            obj_error2.innerText = "End Date cannot be more than 80 years ago";
            obj_error2.style.display = "block";
            event.target.style.color = "#e21224";
            hasError = true;
          } else if (
            start_date_modal !== "" &&
            start_date_modal.isAfter(end_date_modal)
          ) {
            obj_error2.innerText = "End Date cannot be before Start Date";
            event.target.style.border = "1.5px solid #e21224";
            obj_error2.style.display = "block";
            event.target.style.color = "#e21224";
            hasError = true;
          } else if (dateCalc3 > pls3yrs) {
            event.target.style.border = "1.5px solid #e21224";
            event.target.style.border = "1.5px solid #e21224";
            obj_error2.innerText =
              "End Date can be a date no more than 3 years from now";
            obj_error2.style.display = "block";
            event.target.style.color = "#e21224";
            hasError = true;
          } else {
            obj_error2.style.display = "none";
            event.target.removeAttribute("style");
            event.target.style.color = "#555";

            let start_date_error = document.getElementById("start_date_error");
            if (start_date_error.style.display === "block") {
              // run onblur for start_date_modal
              var startdateEvent = new Event("blur");
              Object.defineProperty(startdateEvent, "target", {
                writable: false,
                value: document.getElementById("start_date_modal"),
              });

              onBlur(startdateEvent);
            }
          }
        }
      }
    }
    if (hasError) {
      setFormHasError(true);
    } else {
      setFormHasError(false);
      hasError = false;
    }
  };

  const onFocusState = () => {
    setCntrlWithFocus("");
    let inputs = document.querySelectorAll("button, a");
    try {
      for (let i = 0; i < inputs.length; ++i) {
        inputs[i].addEventListener("focusout", (event) => {
          if (event.relatedTarget == null) {
            setCntrlWithFocus("");
          } else {
            setCntrlWithFocus(event.relatedTarget.id);
          }
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddInstitution = () => {
    if (isAddButtonDisable) return true;
    let degObj = DEGREES.find((o) => o.educationdegreedesc === degree);
    let eduLevel;
    if (currentInstitutionCheck || !isDegreeReceive) {
      eduLevel = 1;
    }
    if (isDegreeReceive) {
      eduLevel = 4;
    }
    if (
      degObj?.educationdegreedesc?.includes("Master") ||
      degObj?.educationdegreedesc?.includes("Doctor")
    ) {
      eduLevel = 6;
    }
    if (isDegreeReceive === "No") {
      eduLevel = 1;
    }
    let instituteInfo = 
      {
        institution_Name: institutionName,
        currentInstitutionCheck: currentInstitutionCheck,
        start_Date: startDate,
        end_Date: endDate,
        city: city,
        state: state,
        country: country,
        receive_Degree_Check: isDegreeReceive,
        majorIn: majorIn,
        educationlevelid: eduLevel,
        degree: degree,
        educationdegreeid: degObj ? degObj.educationdegreeid : null,
      }

    if (isReviewEditInstitution) {
      if(isDegreeReceive === "No"){
        instituteInfo.degree =""
        instituteInfo.majorIn = ""
        instituteInfo.educationdegreeid= null
        instituteInfo.educationlevelid= 1
        setDegree("");
        setMajorIn("");
      }
      instituteInfo = { ...editInstitutionDetails[0], ...instituteInfo };
      updateInstituteData(instituteInfo);
    } else {
      addData(instituteInfo);
    }
    setInitialState();
    setFormHasChanged(false);
    closeAddInstitutionModal(false);
    setIsReviewEditInstitution(false);
  };

  const handleCloseLostDataModal = () => {
    setShowLostDataModal(false);
    closeAddInstitutionModal(true);
    if (editInstitutionDetails.length > 0) setIsReviewEditInstitution(true);
  };

  const handleLostDataProceed = () => {
    setInitialState();
    setFormHasChanged(false);
    handleCloseLostDataModal();
    closeAddInstitutionModal(false);
    setIsReviewEditInstitution(false);
    setEditInstitutionDetails([]);
  };

  const handleClose = () => {
    if (formHasChanged) {
      setShowLostDataModal(true);
    }
    if (isReviewEditInstitution && !formHasChanged) {
      setInitialState();
      setEditInstitutionDetails([]);
    }
    closeAddInstitutionModal(false);
    setIsReviewEditInstitution(false);
  };

  const setInitialState = () => {
    setInstitutionName("");
    setStartDate();
    setEndDate();
    setCity();
    setState();
    setIsDegreeReceive("");
    setCountry();
    setCurrentInstitutionCheck(false);
    setMajorIn("");
    setEnableDegreeOption(false);
    setDegree("");
    setShowState(false);
    setIsAddButtonDisable(true);
  };

  const editInstitutions = useCallback(() => {
    if (editInstitutionDetails.length > 0) {
      editInstitutionDetails.forEach((instituteDetail) => {
        setInstitutionName(instituteDetail.institution_Name);
        setStartDate(instituteDetail.start_Date);
        setEndDate(instituteDetail.end_Date);
        setCity(instituteDetail.city);
        setState(instituteDetail.state);
        setIsDegreeReceive(() => (instituteDetail.degree ? "Yes" : "No"));
        setEnableDegreeOption(() => (instituteDetail.degree ? true : false));
        setCountry(instituteDetail.country);
        setCurrentInstitutionCheck(instituteDetail.currentInstitutionCheck);
        setMajorIn(instituteDetail.majorIn);
        setDegree(instituteDetail.degree);
        setIsAddButtonDisable(false);
      });
    }
  }, [editInstitutionDetails]);

  const isButtonDisable = useCallback(() => {
    if (formHasError) {
      setIsAddButtonDisable(true);
      return;
    }
    const hasBasicField =
      institutionName?.length > 2 &&
      startDate?.length > 2 &&
      (endDate?.length > 2 || currentInstitutionCheck) &&
      city?.length > 1 &&
      country?.length > 0 &&
      !formHasError;
    const needsState = country === "US" ? state?.length > 0 : false;
    const noCollegeAttended = isDegreeReceive === "No";
    const degreeReceived =
      isDegreeReceive === "Yes" && degree?.length > 0 && majorIn?.length > 2;

    if (
      hasBasicField &&
      (noCollegeAttended || degreeReceived) &&
      (country !== "US" || needsState)
    ) {
      setIsAddButtonDisable(false);
    } else {
      setIsAddButtonDisable(true);
    }
  }, [
    institutionName,
    startDate,
    endDate,
    currentInstitutionCheck,
    city,
    country,
    majorIn,
    degree,
    isDegreeReceive,
    state,
    formHasError,
  ]);

  useEffect(() => {
    isButtonDisable();
  }, [isDegreeReceive, majorIn, formHasError, isButtonDisable]);

  useEffect(() => {
    editInstitutions();
  }, [editInstitutions]);

  useEffect(() => {
    if (currentInstitutionCheck) {
      setEndDate(Moment().format("MM/YYYY"));

      let obj_error2 = document.getElementById("end_date_error_modal");
      obj_error2.style.display = "none";

      let enddateevent = document.getElementById("end_date_modal");
      enddateevent.style.removeProperty("color");
      enddateevent.style.removeProperty("border");
      enddateevent.style.color = "#555";
      if (enddateevent.style.color === "rgb(85, 85, 85)") {
        setFormHasError(false);
        setEndDate("");
      }
    } else {
      setEndDate("");
    }
  }, [currentInstitutionCheck]);

  return (
    <>
      <div>
        <div id="institutionModal"></div>
        <div>
          <Modal
            id="addinstitutionModal"
            show={showAddInstitutionModal}
            className="modal-md"
            title=""
          >
            <div>
              <div className="modal-body">
                <div className="container">
                  <div className="row"></div>
                  <div className="row" style={{ marginLeft: "-8px" }}>
                    <div className="col-md-12" style={{ padding: "0" }}>
                      <div className="modal-header">
                        <h3>
                          <div>
                            <span>Add Institution Details</span>
                          </div>
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div style={{ paddingBottom: "10px" }}>
                        <span className="required-field-text">
                          * = Required Field
                        </span>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close modal dialog"
                          onClick={handleClose}
                          style={{ margin: "0" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <label htmlFor="institution_name_modal">
                        <strong>Institution Name*</strong>
                      </label>
                      <input
                        type="text"
                        id="institution_name_modal"
                        className="form-control form-control form-control-15"
                        maxLength={100}
                        minLength={3}
                        value={institutionName}
                        onBlur={onBlur}
                        onChange={handleChange}
                        onKeyDown={onKeyDown}
                        autoComplete="off"
                      ></input>
                      <div
                        id="institution_modal_name_error"
                        className="invalid-feedback"
                      >
                        Please enter the Institution Name
                      </div>
                    </div>
                  </div>
                  <div style={{ paddingTop: "20px" }}>
                    <strong>What dates did you attend?*</strong>
                  </div>
                  <label
                    htmlFor="isCurrentInstitution"
                    className="required-field-text"
                    style={{ marginBottom: "0", paddingTop: "15px" }}
                  >
                    <FormCustomControl
                      id="isCurrentInstitution"
                      inputType="checkbox"
                      label="I am currently attending this institution"
                      onChange={handleChange}
                      checked={currentInstitutionCheck === true}
                    />
                  </label>
                  <div
                    className="row"
                    style={{
                      paddingTop: "20px",
                    }}
                  >
                    <div className="col">
                      <label htmlFor="start_date_modal">
                        <strong> Start Date* </strong>
                      </label>
                      <InputMask
                        id="start_date_modal"
                        mask="99/9999"
                        maskChar="_"
                        className="form-control"
                        placeholder="MM/YYYY"
                        value={startDate}
                        onBlur={onBlur}
                        onChange={handleChange}
                        onKeyDown={onKeyDown}
                        required
                        autoComplete="off"
                      />

                      <div
                        id="start_date_error_modal"
                        className="invalid-feedback"
                      >
                        Please enter a Start Date
                      </div>
                    </div>
                    <div className="col">
                      <label htmlFor="end_date_modal">
                        <strong> End Date* </strong>
                      </label>

                      <InputMask
                        id="end_date_modal"
                        mask="99/9999"
                        maskChar="_"
                        className="form-control"
                        placeholder="MM/YYYY"
                        value={currentInstitutionCheck ? "" : endDate}
                        onBlur={onBlur}
                        onChange={handleChange}
                        onKeyDown={onKeyDown}
                        required
                        disabled={currentInstitutionCheck}
                        autoComplete="off"
                      />

                      <div
                        id={"end_date_error_modal"}
                        className="invalid-feedback"
                      >
                        Please enter an End Date
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ paddingTop: "20px" }}>
                    <div className="col">
                      <label htmlFor="city_modal" aria-label="City">
                        <strong>City*</strong>
                      </label>
                      <input
                        type="text"
                        id="city_modal"
                        className="form-control form-control form-control-15"
                        maxLength={100}
                        minLength={2}
                        value={city}
                        onBlur={onBlur}
                        onChange={handleChange}
                        aria-label="City"
                        onKeyDown={onKeyDown}
                        autoComplete="off"
                      />
                      <div id="city_modal_error" className="invalid-feedback">
                        Please enter a City
                      </div>
                    </div>
                  </div>

                  <div className="row" style={{ paddingTop: "20px" }}>
                    <div className="col">
                      <label id="stateprovince">
                        <strong>
                          State/Province
                          {country === "US" ? "*" : ""}
                        </strong>
                      </label>

                      <DropdownButton
                        id="state_id_modal_opt"
                        type="default"
                        variant="secondary"
                        title={state || "\u00A0"}
                        selected={false}
                        autoComplete="new-address"
                        onSelect={(key, event) => {
                          event.target.id = "state_id_modal_opt";
                          event.target.value = key;
                          handleChange(event);
                        }}
                        onBlur={onBlur}
                        onClick={clickFunc}
                        onFocus={onFocusState}
                        onToggle={handleToggle}
                        required
                      >
                        {STATES.map((state, index) => {
                          return (
                            <div key={index}>
                              <Dropdown.Item
                                eventKey={state.code}
                                id="state_option"
                              >
                                {state.code + " - " + state.name}
                              </Dropdown.Item>
                            </div>
                          );
                        })}
                      </DropdownButton>
                      <div
                        id={"state_modal_id_error"}
                        className="invalid-feedback"
                      >
                        Please choose State/Province
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ paddingTop: "20px" }}>
                    <div className="col">
                      <label htmlFor="country_id_modal">
                        <strong>Country*</strong>
                      </label>
                      <DropdownButton
                        id={"country_id_modal"}
                        type="default"
                        variant="secondary"
                        title={country || "\u00A0"}
                        selected={false}
                        autoComplete="new-address"
                        onSelect={(key, event) => {
                          event.target.id = "country_id_modal";
                          event.target.value = key;
                          handleChange(event);
                        }}
                        onBlur={onBlur}
                        onClick={clickFunc}
                        onFocus={onFocusState}
                        required
                      >
                        {COUNTRIES.map((country, index) => {
                          return (
                            <div key={index}>
                              <Dropdown.Item
                                eventKey={country.code}
                                id="country_option"
                              >
                                {country.code + " - " + country.name}
                              </Dropdown.Item>
                            </div>
                          );
                        })}
                      </DropdownButton>
                      <div
                        id={"country_modal_id_error"}
                        className="invalid-feedback"
                      >
                        Please choose a Country
                      </div>
                    </div>
                  </div>
                  <div
                    className="row"
                    style={{
                      paddingTop: "40px",
                      justifyContent: "space-around",
                    }}
                  >
                    <div style={{ marginLeft: "-15px" }}>
                      <strong>Did you receive a degree?*</strong>
                    </div>
                    <div className="custom-control custom-radio">
                      <input
                        name="radio-guide-degree-recieved"
                        type="radio"
                        id="recievedDegreeYes"
                        className="custom-control-input"
                        value="Yes"
                        onChange={handleChange}
                        checked={isDegreeReceive === "Yes"}
                        required
                      />
                      <label
                        htmlFor="recievedDegreeYes"
                        className="custom-control-label"
                        id="label_recievedDegreeYes"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="custom-control custom-radio">
                      <input
                        name="radio-guide-degree-recieved"
                        type="radio"
                        id="recievedDegreeNo"
                        className="custom-control-input"
                        value="No"
                        onChange={handleChange}
                        checked={isDegreeReceive === "No"}
                        required
                      />
                      <label
                        htmlFor="recievedDegreeNo"
                        className="custom-control-label"
                        id="label_recievedDegreeNo"
                      >
                        No
                      </label>
                    </div>
                    <div
                      id="receivedDegreFillError"
                      className="invalid-feedback"
                    >
                      Please choose a response
                    </div>
                  </div>
                  {enableDegreeOption && (
                    <>
                      <div className="row" style={{ paddingTop: "20px" }}>
                        <div className="col">
                          <label htmlFor="degree_name">
                            <strong>Which Degree did you receive?*</strong>
                          </label>
                          <DropdownButton
                            id="degree_name"
                            type="default"
                            variant="secondary"
                            title={degree || "\u00A0"}
                            selected={false}
                            autoComplete="new-password"
                            onSelect={(key, event) => {
                              event.target.id = "degree_name";
                              event.target.value = key;
                              handleChange(event);
                            }}
                            onBlur={onBlur}
                            onClick={clickFunc}
                            onMouseDown={onKeyDown}
                            onFocus={onFocusState}
                            required
                          >
                            {DEGREES.length > 0 &&
                              DEGREES.map((degree, index) => {
                                return (
                                  <div key={index}>
                                    <Dropdown.Item
                                      eventKey={degree.educationdegreeid}
                                      key={degree.educationdegreeid}
                                      id="degree_option"
                                    >
                                      {degree.educationdegreedesc}
                                    </Dropdown.Item>
                                  </div>
                                );
                              })}
                          </DropdownButton>
                          <div
                            id={"degree_modal_name_error"}
                            className="invalid-feedback"
                          >
                            Please choose which Degree you received
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{ paddingTop: "20px" }}>
                        <div className="col">
                          <label htmlFor="major_in">
                            <strong>What did you Major in?*</strong>
                          </label>

                          <input
                            type="text"
                            id="major_in"
                            className="form-control form-control form-control-15"
                            maxLength={100}
                            minLength={3}
                            value={majorIn}
                            placeholder="ex: Political Science"
                            onBlur={onBlur}
                            onChange={handleChange}
                            onKeyDown={onKeyDown}
                            autoComplete="off"
                          ></input>
                          <div
                            id="major_modal_in_error"
                            className="invalid-feedback"
                          >
                            Please enter your Major
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div
                className="row"
                style={{
                  paddingTop: "40px",
                  paddingBottom: "20px",
                  float: "right",
                }}
              >
                <div
                  className="col-md-12"
                  style={{
                    textAlign: "right",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      margin: "5px 25px",
                      color: "#3174af",
                      cursor: "pointer",
                    }}
                  >
                    <span onClick={handleClose}>
                      <strong> Cancel </strong>
                    </span>
                  </div>

                  <div>
                    <Button
                      label={isReviewEditInstitution ? "Update" : "Add"}
                      onClick={handleAddInstitution}
                      disabled={isAddButtonDisable}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>

      <LostDataModal
        isOpen={showLostDataModal}
        handleClose={handleCloseLostDataModal}
        handleProceed={handleLostDataProceed}
      />
    </>
  );
};

export default InstitutionModal;
